const STORAGE_KEY = 'swarnakamala-wishlist';

function readWishlist() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value)
      ? value
          .map((item) => (typeof item === 'object' ? item : { id: String(item), handle: '' }))
          .filter((item) => item.id)
      : [];
  } catch {
    return [];
  }
}

function escapeHTML(value) {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'INR';
  return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(Number(cents || 0) / 100);
}

function productCard(product) {
  const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
  const price = variant?.price ?? product.price;
  const compareAtPrice = variant?.compare_at_price;
  const isSale = compareAtPrice > price;
  const percent = isSale ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice) : 0;
  const image = product.featured_image || product.images?.[0] || '';
  const url = product.url || `/products/${product.handle}`;

  return `
    <article class="wishlist-card" data-wishlist-page-item="${escapeHTML(product.id)}">
      <a class="wishlist-card__image" href="${escapeHTML(url)}">
        ${image ? `<img src="${escapeHTML(image)}?width=720" alt="${escapeHTML(product.title)}" loading="lazy">` : ''}
        ${isSale ? `<span class="wishlist-card__sale">${percent}% OFF</span>` : ''}
      </a>
      <div class="wishlist-card__details">
        <a class="wishlist-card__title" href="${escapeHTML(url)}">${escapeHTML(product.title)}</a>
        <div class="wishlist-card__price">
          <strong>${formatMoney(price)}</strong>
          ${isSale ? `<s>${formatMoney(compareAtPrice)}</s>` : ''}
        </div>
        <div class="wishlist-card__actions">
          <a class="button button--primary" href="${escapeHTML(url)}">View product</a>
          <button class="button button--secondary" type="button" data-wishlist-remove="${escapeHTML(product.id)}">Remove</button>
        </div>
      </div>
    </article>
  `;
}

async function renderWishlist(root) {
  const items = readWishlist();
  const grid = root.querySelector('[data-wishlist-grid]');
  const empty = root.querySelector('[data-wishlist-empty]');
  const loading = root.querySelector('[data-wishlist-loading]');

  if (!items.length || !items.some((item) => item.handle)) {
    grid.replaceChildren();
    loading.hidden = true;
    empty.hidden = false;
    return;
  }

  empty.hidden = true;
  loading.hidden = false;

  const products = (
    await Promise.all(
      items
        .filter((item) => item.handle)
        .map((item) =>
          fetch(`/products/${encodeURIComponent(item.handle)}.js`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        )
    )
  ).filter(Boolean);

  grid.innerHTML = products.map(productCard).join('');
  loading.hidden = true;
  empty.hidden = products.length > 0;
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-remove]');
  if (!button) return;

  const id = String(button.dataset.wishlistRemove);
  const wishlist = readWishlist().filter((item) => String(item.id) !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: wishlist }));
});

document.addEventListener('wishlist:updated', () => {
  const root = document.querySelector('[data-wishlist-page]');
  if (root) renderWishlist(root);
});

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-wishlist-page]');
  if (root) renderWishlist(root);
});
